export const TABLET_BREAKPOINT = 1280;
export const MOBILE_BREAKPOINT = 768;
export const YANDEX_METRICS_ID = 100002395;
export const YANDEX_MERCHANT_ID = '9587af93-65f3-4921-8fb5-4d05356952ae';
export const APP_VERSION = process.env.APP_VERSION;
